import React from 'react'
import { useTranslation } from 'react-i18next'
import { Dialog } from 'vnetwork-ui'
import { ModalProps } from '@/types/shared'
import LeadConversionFlowCompact from '../../../modules/Marketing/components/Detail/LeadConversionFlowCompact'

const LeadStatusLegendModal: React.FC<ModalProps> = ({ open, onClose }) => {
    const { t } = useTranslation('marketing')

    return (
        <Dialog
            open={open}
            onClose={onClose}
            title={t('lead_flow.title')}
            maxWidth="lg"
        >
            <div className="min-w-[700px]">
                <p className="text-xs text-gray-500 mb-4">
                    {t('lead_flow.subtitle')}
                </p>
                <LeadConversionFlowCompact hideTitle />
            </div>
        </Dialog>
    )
}

export default LeadStatusLegendModal
